module.exports = __webpack_public_path__ + "static/img/hbyh.37e7bd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hbyh.png
// module id = Labm
// module chunks = 0